import { isDefined } from '@sgme/fp';
import { Component, type ErrorInfo, type PropsWithChildren } from 'react';

import { AppCrashModal } from '@/components/fatality/AppCrashModal.tsx';
import { ReduxErrorCatcher } from '@/components/fatality/ReduxErrorCatcher.tsx';
import { logger } from '@/components/SgwtBootstrap/logger.ts';

type Props = PropsWithChildren;

type State = {
  error?: Error;
};

export class GlobalCatchAll extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.logError(
      'Global Error boundary caught: {error_s} {errorInfo_s}',
      JSON.stringify(error),
      JSON.stringify(errorInfo),
    );
  }

  handleReload() {
    window.location.reload();
  }

  render() {
    if (isDefined(this.state.error)) {
      return <AppCrashModal error={this.state.error} onReload={this.handleReload} />;
    }

    return <ReduxErrorCatcher>{this.props.children}</ReduxErrorCatcher>;
  }
}
